<template>
  <div id="history-crypto">
    <div class="vx-row mb-base" >
      <div class="vx-col w-full">
        <vx-card :title="$t('List of crypto deposits and withdrawals')"
                 :subtitle="$t('You can enter the name and symbol of the currency, transaction ID, etc. in the search field.')">

          <div slot="no-body" class="mt-4" ref="historyTableCrypto">
            <vs-table class="table-dark-inverted"
                      :data="historyOrders"
                      :noDataText="$t('No data Available')"
                      :sst="true"
                      v-model="selected"
                      :stripe="true"
                      @search="handleSearch"
                      search>
              <template slot="header">
                <div class="vx-col lg:w-1/6 md:w-1/3 w-1/2 mr-1 hidden md:inline-block">
                  <vs-select v-model="filterModel" class="w-full input-rounded-full">
                    <vs-select-item :key="index" :value="item.value" :text="$t(item.text)" v-for="(item,index) in filterModelOptions" class="w-full" />
                  </vs-select>
                </div>
                <div class="vx-col lg:w-1/6 md:w-1/3 w-1/2 mr-1 hidden md:inline-block">
                  <vs-select v-model="filterStatus" class="w-full input-rounded-full">
                    <vs-select-item :key="index" :value="item.value" :text="$t(item.text)" v-for="(item,index) in filterStatusOptions" class="w-full" />
                  </vs-select>
                </div>
                <div class="vx-col lg:w-1/6 md:w-1/3 w-1/2">
                  <vs-select v-model="filterFor" class="w-full input-rounded-full">
                    <vs-select-item :key="index" :value="item.value" :text="$t(item.text)" v-for="(item,index) in filterForOptions" class="w-full" />
                  </vs-select>
                </div>
              </template>

              <template slot="thead">
                <vs-th>ردیف</vs-th>
                <vs-th>تاریخ و زمان</vs-th>
                <vs-th>نوع تراکنش</vs-th>
                <vs-th class="w-90">ارز</vs-th>
                <vs-th class="w-90">مقدار</vs-th>
                <vs-th class="w-90">وضعیت</vs-th>
                <vs-th class="w-90">توضیحات</vs-th>
                <vs-th class="text-center">جزئیات</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" style="height: 65px">
                  <vs-td :data="data[indextr]">
                    <span class="flex items-center px-2 py-1 rounded" v-if="!loadData">{{( indextr +1) + (limit * page)-limit}}</span>
                  </vs-td>
                  <vs-td :data="data[indextr].DateTime">
                    <span class="flex items-center px-2 py-1 rounded vazir">{{data[indextr].DateTime}}</span>
                  </vs-td>
                  <vs-td :data="data[indextr].type">
                    <span class="flex items-center pr-2 py-1">
                      <div class="h-3 w-3 rounded-full mr-2" :class="'bg-' + (data[indextr].type == 'deposit'? 'success' : 'danger' )"></div>
                      {{$t(data[indextr].type)}}
                    </span>
                  </vs-td>
                  <vs-td :data="data[indextr].Crypto" class="text-wrap">
                    <div class="flex">
                      <span class="mr-2">
                        <i class="text-3xl cf" v-if="isFontExist(data[indextr].coin.symbol)" :style="{color:colorSymbol(data[indextr].coin.symbol)}" :class="'cf-'+data[indextr].coin.symbol.toLowerCase()"></i>
                        <img :src="publicPath+'images/currency/' + iconSymbol(data[indextr].coin.symbol)" width="27px" v-else />
                      </span>
                      <span> {{getNameCoin(data[indextr].coin.symbol)[islocale]}}</span>
                    </div>
                  </vs-td>
                  <vs-td :data="data[indextr].amount">
                    <span>{{toFixFloat(data[indextr].amount) + '' + data[indextr].coin.symbol}}</span>
                  </vs-td>
                  <vs-td :data="data[indextr].status">
                    <span>
                      <vs-chip v-if="data[indextr].status == 'success'" color="success">{{$t(data[indextr].status)}}</vs-chip>
                      <vs-chip v-else-if="data[indextr].status == 'pending'" color="warning">{{$t(data[indextr].status)}}</vs-chip>
                      <vs-chip v-else-if="data[indextr].status == 'reject' || data[indextr].status == 'unsuccessful'" color="danger">{{$t(data[indextr].status)}}</vs-chip>
                    </span>
                  </vs-td>
                  <vs-td :data="data[indextr].description">
                    <span>{{data[indextr].description ? $t(data[indextr].description) : '-----'}}</span>
                  </vs-td>
                  <vs-td class="text-center">
                    <span @click="popupDetail=true;idTransaction=data[indextr].id">
                        <feather-icon icon="AirplayIcon" class="text-primary px-6"></feather-icon>
                    </span>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
            <vs-pagination class="mt-4 pb-3 px-3 vazir" :total="Math.ceil(historyOrdersCount/limit)" v-model="page"></vs-pagination>

          </div>

        </vx-card>
      </div>
    </div>

    <div v-if="idTransaction">
      <CryptoDetail :popupDetail="popupDetail" :idTransaction="idTransaction" v-on:popupDetailChange="updatePopupDetail"/>
    </div>

  </div>
</template>
<i18n locale="fa">
{
  "Trading transactions":"تراکنش های معاملات"
  ,"Order transactions from us":"تراکنش های سفارش از ما"
  ,"Other wallet transactions":"تراکنش های کیف پول دیگر"
  ,"all transactions":"همه تراکنش ها"
  ,"List of coin deposits and withdrawals":"لیست واریز و برداشت های {coin}"
  ,"List of crypto deposits and withdrawals":"لیست واریز و برداشت های رمزارز"
  ,"You can enter the name and symbol of the currency, transaction ID, etc. in the search field.":
    "میتوانید در قسمت جستجو نام و نماد ارز، شناسه تراکنش و ... را درج کنید."
}
</i18n>
<i18n locale="fa">
{
  "List of coin deposits and withdrawals":"List of {coin} deposits and withdrawals"
}
</i18n>
<script>
import CryptoDetail from './CryptoDetail'
import axios from "../../../../axios";
export default {
  name: 'Crypto',
  props:['coin'],
  data () {
    return {
      filterModelOptions: [
        {text: 'deposit & withdraw', value:''},
        {text: 'deposit', value:'deposit'},
        {text: 'withdraw', value:'withdraw'}
      ],
      filterModel:'',
      filterStatusOptions: [
        {text: 'all situations', value:''},
        {text: 'success', value:'success'},
        {text: 'pending', value:'pending'},
        {text: 'unsuccessful', value:'unsuccessful'},
        {text: 'reject', value:'reject'}
      ],
      filterStatus:'',
      filterForOptions: [
        {text: 'all transactions', value:''},
        {text: 'Trading transactions', value:'trades'},
        {text: 'Order transactions from us', value:'orders'},
        {text: 'Other wallet transactions', value:'wallets'},
      ],
      filterFor:'',

      page: 1,
      limit: 10,
      loadData: true,
      search: '',

      popupDetail: false,
      idTransaction:null,

      selected: [],
      historyOrders: [],
      historyOrdersCount: 0
    }
  },
  components:{
    CryptoDetail
  },
  watch:{
    page(value){
      this.getList()
    },
    filterModel(){
      this.getList()
    },
    filterStatus(){
      this.getList()
    },
    filterFor(){
        this.getList()
    }
  },
  methods: {
    getList(){
      this.loadData = true;
      if(this.page!=1)
        this.$vs.loading({
          container: this.$refs.historyTableCrypto,
          scale: 0.65
        })

      const self = this
      axios.post('/history/crypto-transaction',{page: this.page , filterModel:this.filterModel, filterStatus:this.filterStatus,coin:this.coin,
        filterFor:this.filterFor ,search:this.search})
        .then(function (response) {
          self.historyOrders = response.data.transaction;
          self.historyOrdersCount = response.data.transaction_count;

          self.$vs.loading.close(self.$refs.historyTableCrypto)
          self.loadData = false;

          /*if( response.data.notif === true)
            self.$store.dispatch('SET_REFRESH_NOTIF', {status: !self.refreshNotifications})*/
        }).catch(function (error) { console.log(error); self.loadData = false; self.$vs.loading.close(self.$refs.historyTableCrypto)  })
    },
    handleSearch(searching){
      this.search = searching;
      this.getList();
    },
    updatePopupDetail (value) {
      this.popupDetail = value;
      if(!value){
        setTimeout(()=>{
          this.idTransaction = null;

        },50)
      }
    }
  },
  created() {
    if(this.coin)
      this.filterFor = 'wallets'
    else
      this.getList()
  }
}
</script>

<style lang="scss">
  #history-crypto {
    th.text-center div{
      text-align: center;
      display: block;
    }

    .ul-tabs .vs-tabs--li button {
      font-weight: bold;
      font-size: 16px;
    }

    table td{
      white-space: nowrap;
    }

    .font-large-6 {
      font-size: 115px;
    }

    .w-90 .vs-table-text{
      min-width: 90px;
    }

    .header-table.vs-table--header{
      padding-left: 10px;
      padding-right: 10px;
    }


    .vs-input--label{
      font-size: 15px;
    }

    .input-rounded-full .input-select-con .vs-select--input {
      border-radius: 20px;
    }

    @media only screen and (max-width: 400px) {
      .con-input-search.vs-table--search{
        width: 50%;
        margin: 0px 5px 0px 5px;
      }
    }
  }
  .theme-dark #history-crypto .table-dark-inverted.stripe table tr:nth-child(even){
    background: #182a3a !important;
  }
</style>
